export const getGDPRConsent = (window: Window): string | undefined => {
    const eupubconsent = window.document.cookie
        .split(';')
        .find(row => row.trim().startsWith('eupubconsent-v2'));
    return eupubconsent?.split('=')[1];
};
